import { useContext } from 'react';
import { useQuery } from 'react-query';
import {
  parsePaymentRemarkKey,
  paymentRemarkKeys,
} from '../../cache-keys/paymentRemarkKeys.tsx';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { payment_remark_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function.ts';

export function usePaymentRemarks(personID: string | undefined | null) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = paymentRemarkKeys.root({
    personID,
  });
  return useQuery(
    cacheKey,
    queryFunction(
      payment_remark_api.find(api),
      ({ queryKey }) => parsePaymentRemarkKey(queryKey).person ?? ''
    ),
    {
      enabled: state.user.token.length > 0 && personID !== undefined,
    }
  );
}
